import Vue from 'vue';
import Calculator from '~/components/calculator/base.vue';

Vue.component('Calculator', Calculator);
